import React from "react"

export const SuccessRoundedTick: React.FC = (): JSX.Element => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <rect width="25.7143" height="25.7143" transform="translate(0.143066 0.142822)" fill="#074DFF"/>
            <path d="M19.3514 6.57141L10.0571 15.8714L5.94286 11.7543L4 13.7143L10.0571 19.7771L21.3171 8.51427L19.3514 6.57141Z" fill="white"/>
        </svg>
    )
}